import { Component, OnInit, ViewChild, ElementRef, Input, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, FormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { Location } from '@angular/common'
import { InventoryService } from '../../services/inventory.service';
import { OrdersService } from '../../services/orders.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { GlobalsService } from '../../services/globals.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { merge, fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, startWith, tap, delay } from 'rxjs/operators';
import { interval, Subscription, Observable } from 'rxjs';


@Component({
	selector: 'app-item-query',
	templateUrl: './item-query.component.html',
	styleUrls: ['./item-query.component.scss']
})
export class ItemQueryComponent implements OnInit {

	@Input() stockid;
	@ViewChild('itemsearch') customersearch: ElementRef;
	@ViewChild('itemdetails') itemDetails: ElementRef;
	itemSearchControl = new UntypedFormControl('');
	categoryControl = new UntypedFormControl('');
	productLineControl = new UntypedFormControl('');
	searching = false;
	searchfield = [];
	items: any = [];;
	allitems: any = [];
	header: any = [];
	results: any = [];
	inventorysearching: any;
	itemsearchsubscription: any;
	categories: any = false;
	productlines: any = false;
	user: any = false;
	item_details: any = false;
	include_disabled = new UntypedFormControl(false);
	headercolumns: any = [
		'stockid',
		'lineid',
		'description',
		'qoh',
		'cost',
		'price',
		'supplierno',
	];

	color: any = 'blue'
	dataSource: MatTableDataSource < any > ;
	private sort: MatSort;
	running: any = false;

	dataObs: Observable < any > ;
	items_per_page = [25, 50, 100, 500];
	pagesizedefault = 100;
	salestypes: any = false;

	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

	@ViewChild(MatSort) set matSort(ms: MatSort) {
		this.sort = ms;
		this.setDataSourceAttributes();
	}

	@ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {

		this.paginator = mp;
		this.setDataSourceAttributes();
	}

	setDataSourceAttributes() {
		this.dataSource.paginator = this.paginator;
	}

	constructor(private modalService: NgbModal, private globalsService: GlobalsService, private _changeDetectorRef: ChangeDetectorRef,private route: ActivatedRoute, private formBuilder: UntypedFormBuilder, public router: Router, private location: Location, public inventoryService: InventoryService, public orderService: OrdersService, private globalSearchService: GlobalSearchService) {
		this.inventoryService.getItemCategories().subscribe(c => {
			this.categories = c
		});
		this.inventoryService.getItemProductlines().subscribe(p => {
			this.productlines = p
		})
		this.globalSearchService.userData.subscribe(r => {
			this.user = r;
		});

		this.color = this.globalSearchService.getColor();

		this.globalSearchService.all_system_types.subscribe( (r:any) => {
			if(!r) {
				this.globalsService.getTypes().subscribe(async (results: any) => {
					this.salestypes = results.salestypes;
				});
			} else {
				this.salestypes = r.salestypes;
			}
		});





	}

	getTotalQoh(itemqoh: any) {
		let total_qoh = 0;
		if (itemqoh) {
			itemqoh.forEach(q => {
				if (q.loccode == this.user.user.defaultlocation.loccode) {
					total_qoh += parseFloat(q.quantity);
				}
			});
		}
		return total_qoh;
	}

	ngOnInit(): void {
		this.searching = false;
		this.setPagination([])
	}

	searchItems() {
		this.searching = true;

		if (this.inventorysearching) {
			this.inventorysearching.unsubscribe()
		}

		const search = {
			stockid: this.itemSearchControl.value,
			category: this.categoryControl.value,
			productlines: this.productLineControl.value,
			discontinued: this.include_disabled.value,
			price: 'default',
		}

		this.inventorysearching = this.inventoryService.lookup(search).subscribe((items: any) => {
			this.allitems = items
			this.searching = false;
			this.setPagination(items);
		});
	}

	clearForm() {
		this.itemSearchControl.setValue('');
		this.allitems = [];
		this.items = [];
		this.searching = false;
	}

	back(): void {
		this.location.back();
	}

	viewItem(row: any) {
		this.allitems = [];
		this.items = [];
		this.itemSearchControl.setValue('');
		this.router.navigate(['/inventory/view/' + row.stockid])
	}

	setPagination(tableData) {
		this.dataSource = new MatTableDataSource < any > (tableData);
		this._changeDetectorRef.detectChanges();
		this.dataSource.paginator = this.paginator;
		this.dataObs = this.dataSource.connect();
	}

	openModal(content, item) {

		this.item_details = item;
		this.modalService.open(content, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {
			this.item_details = false;
		});
	}


	announceSortChange(input: any) {

	}

	toHTML(input) : any {
		return new DOMParser().parseFromString(input, 'text/html').documentElement.textContent;
	}

}
